var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "replay",
    transform: "translate(-299 -651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "replay-2",
    "data-name": "replay",
    transform: "translate(299 651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423",
    transform: "translate(0.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_774",
    "data-name": "Caminho 774",
    d: "M45.032,0l-.488.515,2.374,2.506H36.849a3.564,3.564,0,0,0-3.46,3.652V8.944h.69V6.674a2.853,2.853,0,0,1,2.77-2.924H46.918L44.544,6.256l.488.515,3.207-3.386Z",
    transform: "translate(-33.389)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(0 8.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_775",
    "data-name": "Caminho 775",
    d: "M43.472,244.716v2.271a2.853,2.853,0,0,1-2.77,2.924H30.634l2.374-2.507-.488-.515-3.207,3.386,3.207,3.386.488-.515-2.374-2.506H40.7a3.564,3.564,0,0,0,3.46-3.653v-2.271h-.69Z",
    transform: "translate(-29.313 -244.716)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.1b4afb4132ca51323be76cdfa8732a09.svg";
export { ForwardRef as ReactComponent };